// extracted by mini-css-extract-plugin
export default {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__eWllN","active":"IsCopiedMessage_active__wH0FH"};